export default __webpack_public_path__ + "static/gymgir2021-7d55decdc99782a514bbf4038b01571b.png";